module.exports = __webpack_public_path__ + "static/img/relation.0cbfd96.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/relation.png
// module id = 924
// module chunks = 1